const isProduction = process.env.NODE_ENV !== 'production'
const targetOrigin = process.env.VUE_APP_ORIGIN_URL

export default {
  mounted() {
    window.addEventListener('message', this.receiveCrossMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', () => {})
  },
  watch: {
    continueOrder(newValue) {
      console.log(newValue)
    },
  },
  methods: {
    translateMessage(event) {
      return JSON.parse(event.data)
    },
    preparePostMessage(action, data) {
      return JSON.stringify({ action, data })
    },
    sendMessageToSpotlight(action, data) {
      try {
        console.log(this.preparePostMessage(action, data))
        console.log(targetOrigin)
        parent.postMessage(this.preparePostMessage(action, data), targetOrigin)
      } catch (e) {
         console.error(e)
      }
    },
    prepareCrossMessage(action, data) {
      return this.preparePostMessage(action, data)
    },
    async makeAction(action, success, data = {}) {
      console.log('continueOrder: ', this.continueOrder)
      // TODO: Here will be logic of processing spotlight shop responses
      if (action === 'addToCart') {
        this.$store.commit('order/submitButton/endLoader')

        if (success && this.continueOrder === false) {
          this.$store.commit('order/submitButton/setAddedToCart')
        }
      } else if (action === 'editCartItem') {
        // TODO load edit data
        const articleOrderId = data.articles[0]
        await this.$router.push({
          name: 'edit-curtain',
          params: { articleOrderId },
        })
        // if some error was occurred
        // prepare cross message and notify them about it
        // return this.prepareCrossMessage(action, data)
      }
      return null
    },
    async receiveCrossMessage(event) {
      // Do we trust the sender of this message? on production build only!
      const expectedOrigin = process.env.VUE_APP_ORIGIN_URL
      if (isProduction && event.origin !== expectedOrigin) {
        console.warn(
          'got cross-browser message ' + 'with wrong origin',
          event.origin
        )
        return null
      }
      console.log('Got message from', event.origin)
      console.log('Source', event.source, 'Data: ', event.data)
      const { action, success, data } = this.translateMessage(event)
      const responseCrossMessage = await this.makeAction(action, success, data)
      if (responseCrossMessage) {
        this.sendCrossMessage(event, responseCrossMessage)
      }
    },
    sendCrossMessage(event, message) {
      if (isProduction) event.source.postMessage(message, event.origin)
    },
  },
}
